import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

import restaurantapi from '@/shared/api/restaurant';


export const store = createStore({
    plugins: [createPersistedState({
        key: 'vuex-restaurant'
    })],
    state: {
    
        configuration: null,
 
    },
    getters: {
        operaSystemStatus(state) {
            return state.configuration.SystemStatuses.find(x => x.System == "Opera");
        },
        golfSystemStatus(state) {
            return state.configuration.SystemStatuses.find(x => x.System == "Golf");
        },
        restaurantSystemStatus(state) {
            return state.configuration.SystemStatuses.find(x => x.System == "Restaurant");
        },
        spaSystemStatus(state) {
            return state.configuration.SystemStatuses.find(x => x.System == "Spa");

        },
        configuration(state) {
            return state.configuration;
        },
       
    },
    actions: {
        getConfiguration(context) {
 
            return new Promise((resolve) => {
                restaurantapi.getConfiguration(t => {
           
                    context.commit('setConfiguration', t);
                    resolve(t);
                });
            });
        },
    
 
        clear(context) {
            return new Promise((resolve) => {
                context.commit('setConfiguration', null);
                resolve();
            });
        },
        
    },
    mutations: {
        setConfiguration(state, payload) {
            state.configuration = payload;
        }
    }
});
